import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { partnerManagementFeature, PartnerManagementEffects } from './store';

export function providePartnerManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(partnerManagementFeature),
    provideEffects(PartnerManagementEffects),
  ]);
}
